// extracted by mini-css-extract-plugin
export var auditCompact = "pieChart-module--auditCompact--82c7b";
export var chart = "pieChart-module--chart--3cdca";
export var colourBox = "pieChart-module--colourBox--8643c";
export var compact = "pieChart-module--compact--5ca6f";
export var label = "pieChart-module--label--1c10f";
export var legend = "pieChart-module--legend--0c620";
export var wrapper = "pieChart-module--wrapper--905b9";